<template>
   <div class="layout layout-help-center">
      <!-- Header -->
      <div class="help-center-header">
         <h2>Help Center</h2>
      </div>

      <!-- Navbar -->
      <div class="help-center-tabs">
         <nav>
            <ul>
               <li>
                  <NuxtLink to="/help-center">Topics</NuxtLink>
               </li>
               <li>
                  <NuxtLink to="/help-center/faqs">FAQ</NuxtLink>
               </li>
               <li>
                  <NuxtLink to="/help-center/contact">Contact Us</NuxtLink>
               </li>
            </ul>
         </nav>
      </div>

      <!-- Content that changes based on the route -->
      <div class="help-center-content">
         <NuxtPage />
      </div>
   </div>
</template>

<script setup lang="ts"></script>

<style lang="scss">
@import url("~/assets/scss/help-center/help-center.scss");
</style>
